import { render } from "./RecipeRating.vue?vue&type=template&id=dfe99562"
import script from "./RecipeRating.vue?vue&type=script&lang=js"
export * from "./RecipeRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__